import axios from "@/lib/axios";

// Returns the raw array — used by useSponsorships (no pagination)
export const getAllSponsorships = async (params = {}) => {
  const { data } = await axios.get("/sponsorships", { params });
  return data.data;
};

// Returns the full response envelope {data, total, page, pages}
// Used by useInfiniteSponsorships
export const getSponsorshipsPage = async (params = {}) => {
  const { data } = await axios.get("/sponsorships", { params });
  return data;
};

// Returns { chapters, mahalluNames } for filter pill population
export const fetchSponsorshipMeta = async (params = {}) => {
  const { data } = await axios.get("/sponsorships/meta", { params });
  return data;
};

export const getSponsorship = async (id) => {
  const { data } = await axios.get(`/sponsorships/${id}`);
  return data.data;
};

export const createSponsorship = async (sponsorshipData) => {
  const { data } = await axios.post("/sponsorships", sponsorshipData);
  return data.data;
};

export const updateSponsorship = async ({ id, ...sponsorshipData }) => {
  const { data } = await axios.put(`/sponsorships/${id}`, sponsorshipData);
  return data.data;
};

export const deleteSponsorship = async (id) => {
  const { data } = await axios.delete(`/sponsorships/${id}`);
  return data.data;
};

export const recordSponsorshipPayment = async ({ id, amount }) => {
  const { data } = await axios.post(`/sponsorships/${id}/record-payment`, {
    amount,
  });
  return data.data;
};
